import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRouteDep = ({children}) => {
    const token = localStorage.getItem('token');
    const rol = localStorage.getItem('rol');
    const area_type = localStorage.getItem('area_type');
    
    if (token !== null && (rol === 'ADMIN'  || rol === 'PRIMER_CONTACTO' || area_type === 'REGISTRO')) {
        return children
    } else {
        return <Navigate to="/login" replace={true} />
    }

}

export default PrivateRouteDep;